import type { ControllerDescription } from '@/features/controller/types'

export function renderControllerName(controller: ControllerDescription) {
  if (controller.label && controller.equipmentNumber) {
    return `${controller.label} (№ ${controller.equipmentNumber})`
  } else if (controller.label) {
    return controller.label
  } else if (controller.equipmentNumber) {
    return controller.equipmentNumber.toString()
  } else {
    return controller.id
  }
}
